import { useState } from 'react';
import { Dealer } from '../../../../domains/Dealer';
import { useRevealDealerPhoneMutation } from './useRevealDealerPhoneMutation';

const useDealerContactDetails = (dealer: Dealer) => {
  const [showEmail, setShowEmail] = useState(false);
  const [isLocationOpen, setLocationOpen] = useState(false);
  const [dealerPhone, setDealerPhone] = useState('');
  const revealPhoneMutation = useRevealDealerPhoneMutation();

  const handleShowPhoneNumber = () => {
    if (dealerPhone) return;
    revealPhoneMutation.mutate(dealer.id, {
      onSuccess: (data) => {
        setDealerPhone(data.displayFormat);
      },
    });
  };

  return {
    dealerPhone,
    handleShowPhoneNumber,
    isSubmitting: revealPhoneMutation.isPending,
    isLocationOpen,
    setLocationOpen,
    showEmail,
    setShowEmail,
  };
};

export { useDealerContactDetails };
